import React from 'react';
import styled from "styled-components";
import {FilterDispatcherContext} from "@providers/filters";
import CheckboxListGroup, {CheckboxGroupBox, CheckboxGroupLabel, CheckboxInput} from "@atoms/checkbox.list.group";
import RadiusGenerate from "@helpers/radius.generate";
import ConvertPixelToRem from "@helpers/convert.rem";
import Switch from "@atoms/switch";
import Icon from "@atoms/icon";
import CloseIcon from "@icons/close.svg";
import Badges from "../../../atoms/badges";

export default function HasPoolFilter(props) {
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    const {show, checked} = props.items;

    function handleChange(event) {
        filterDispatcher({
            type: 'HAS_POOL',
            payload: !checked
        });
    }

    return (
        <HasPool className={'d-block ' + (typeof props.className !== "undefined" ? props.className : '')}>
            <Switch label="استخردار" id="has_pool" name="has_pool" labelClassName="w-100" checked={checked} onChange={(e) => handleChange(e)}/>
        </HasPool>
    )
}

const HasPool = styled.div`
    padding: 12px 0;
    
    .close-icon {
        margin-left: -8px;
        
        svg {
            g,path {
                stroke: #ffffff !important;
                stroke-width: 2.2px;
            }
        }
    }
`;